import { useState } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { usePaymentSchedules } from "@/hooks/usePaymentTracking";
import { Calendar, Plus, Save } from "lucide-react";

export function PaymentScheduleManager({ workspaceId }: { workspaceId: string }) {
  const [showForm, setShowForm] = useState(false);
  const [schedule, setSchedule] = useState({
    supplier_id: "",
    payment_terms: "net_30",
    auto_payment: false,
  });

  const handleSave = async () => {
    // In production, this would call an edge function
    console.log("Creating payment schedule:", schedule);
    setShowForm(false);
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Calendar className="h-5 w-5" />
          Payment Schedule Configuration
        </CardTitle>
        <CardDescription>
          Set up automatic payment schedules for suppliers
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        {showForm ? (
          <div className="space-y-4 p-4 border rounded-lg bg-muted/20">
            <div className="space-y-2">
              <Label>Supplier</Label>
              <Select
                value={schedule.supplier_id}
                onValueChange={(value) => setSchedule({ ...schedule, supplier_id: value })}
              >
                <SelectTrigger>
                  <SelectValue placeholder="Select supplier" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="supplier1">Energy Corp</SelectItem>
                  <SelectItem value="supplier2">Water Services</SelectItem>
                  <SelectItem value="supplier3">Telecom Provider</SelectItem>
                </SelectContent>
              </Select>
            </div>

            <div className="space-y-2">
              <Label>Payment Terms</Label>
              <Select
                value={schedule.payment_terms}
                onValueChange={(value) => setSchedule({ ...schedule, payment_terms: value })}
              >
                <SelectTrigger>
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="immediate">Immediate</SelectItem>
                  <SelectItem value="net_7">Net 7 Days</SelectItem>
                  <SelectItem value="net_15">Net 15 Days</SelectItem>
                  <SelectItem value="net_30">Net 30 Days</SelectItem>
                  <SelectItem value="net_60">Net 60 Days</SelectItem>
                  <SelectItem value="net_90">Net 90 Days</SelectItem>
                </SelectContent>
              </Select>
            </div>

            <div className="flex gap-2">
              <Button onClick={handleSave}>
                <Save className="h-4 w-4 mr-2" />
                Save Schedule
              </Button>
              <Button variant="outline" onClick={() => setShowForm(false)}>
                Cancel
              </Button>
            </div>
          </div>
        ) : (
          <Button onClick={() => setShowForm(true)}>
            <Plus className="h-4 w-4 mr-2" />
            Create Payment Schedule
          </Button>
        )}
      </CardContent>
    </Card>
  );
}
